import { ContainerDetailsModel, ContainerType } from 'src/components/common/container-details/ContainerDetailsModel';
import { GetContainerDetailsOutput } from 'src/models/GetContainerDetails';

export const getChildContainerTypeForParent = (parentType?: ContainerType): ContainerType | undefined => {
    switch (parentType) {
        case ContainerType.STACKING_AREA:
        case ContainerType.DROP_ZONE:
        case ContainerType.TRAILER:
            return ContainerType.PALLET;
        case ContainerType.PALLET:
            return ContainerType.TOTE;
        case ContainerType.TOTE:
            return ContainerType.ITEM;
        default:
            return undefined;
    }
}

export const getChildrenType = (container?: ContainerDetailsModel): ContainerType | undefined => {
    return getChildContainerTypeForParent(container?.containerType);
}

export const getChildrenCount = (container?: ContainerDetailsModel): number | undefined => {
    return container?.numOfChildContainers;
}

export const getGrandChildrenType = (containerDetails?: GetContainerDetailsOutput): ContainerType | undefined => {
    const childContainerType = containerDetails?.childContainers?.[0]?.containerType;
    return getChildContainerTypeForParent(childContainerType);
}

export const getGrandChildrenCount = (containerDetails?: GetContainerDetailsOutput): number | undefined => {
    return containerDetails?.childContainers?.reduce((count, child) => count + (child.numOfChildContainers || 0), 0);
}

export const INVENTORY_CREATED = 'InventoryCreated';

export const containsInventoryItem = (containerDetails?: GetContainerDetailsOutput): boolean => {
    if (containerDetails?.container?.containerType !== ContainerType.TOTE) {
        return false;
    }
    return containerDetails?.childContainers?.some(
        child => child.containerProperties?.inventoryCreationStatus === INVENTORY_CREATED
    ) ?? false;
}
